/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Addr_Sugg_Edit_LabelInputs */

const cs_addr_sugg_edit_label = /** @type {(inputs: Addr_Sugg_Edit_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upravit ${i?.field}`)
};

const en_addr_sugg_edit_label = /** @type {(inputs: Addr_Sugg_Edit_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edit ${i?.field}`)
};

/**
* | output |
* | --- |
* | "Edit {field}" |
*
* @param {Addr_Sugg_Edit_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_edit_label = /** @type {((inputs: Addr_Sugg_Edit_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_Edit_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_edit_label(inputs)
	return cs_addr_sugg_edit_label(inputs)
});